// extracted by mini-css-extract-plugin
export var settingsList = "_32-0";
export var settingsRow = "_32-1";
export var warningDot = "_32-2";